import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import b from 'b_';
import cn from 'classnames';
import FlagStore from '../../stores/FlagStore';
import Button, { Loader } from '../Button';
import './WidgetBase.css';

const block = b.lock('WidgetBase');

class WidgetBase extends Component {
    static propTypes = {
        title: PropTypes.node.isRequired,
        flipClassName: PropTypes.string,
        infoTitle: PropTypes.string,
        infoBody: PropTypes.string,
        loading: PropTypes.bool,
        flipStore: FlagStore.PropType,
    };

    render() {
        const hasBackSide = !!this.props.flipStore;
        const flip = hasBackSide ? this.props.flipStore.value : false;
        return <div className={block({ flip })}>
            <div className={block('Container', { flip })}>
                {this.props.title ? <div
                    className={block('Title')}
                >{this.props.title}</div> : null}
                <div className={block('Body')}>
                    {this.props.children}
                    {hasBackSide ? <Button
                        className={cn(block('Flip'), this.props.flipClassName)}
                        icon="info_outline"
                        onClick={this.props.flipStore.toggle}
                    /> : null}
                    {this.props.loading ? <div className={block('LoaderWrapper')}>
                        <Loader className={block('Loader')} />
                    </div> : null}
                </div>
            </div>
            {hasBackSide ? <div className={block('Container', { back: true, flip: !flip })}>
                {this.props.infoTitle ? <div
                    className={block('Title', { info: true })}
                    title={this.props.infoTitle}
                >{this.props.infoTitle}</div> : null}
                {this.props.infoBody ? <div className={block('InfoBody')}>
                    {this.props.infoBody}
                </div> : null}
                <Button
                    className={cn(block('Flip', { back: true }), this.props.flipClassName)}
                    icon="close"
                    onClick={this.props.flipStore.toggle}
                />
            </div> : null}
        </div>;
    }
}

export default observer(WidgetBase);
